
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M23.43 10.52c-2.64-2.91-7-6-11.43-5.92S3.21 7.61.57 10.52a2.22 2.22 0 000 3C2.33 15.42 6.74 19.4 12 19.4s9.66-4 11.43-5.93a2.22 2.22 0 000-2.95zM7.4 12a4.6 4.6 0 114.6 4.6A4.6 4.6 0 017.4 12z"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"2"}})])])
          )
        }
      }
    